document.addEventListener('DOMContentLoaded', function() {
  function initVariant(){
    let currentId = document.querySelector('[data-current-id]').dataset.currentId;
    console.log(currentId, 'currentId');
    switch (currentId) {
      case '9599908970813':
        document.querySelector('#swap-product--hybrid input').checked = true;
        break;
      case '9599909167421':
        document.querySelector('#swap-product--hybrid input').checked = true;
        break;
      case '9599908708669':
        document.querySelector('#swap-product--hybrid input').checked = true;
        break;
      case '9599908577597':
        document.querySelector('#swap-product--memory-foam input').checked = true;
        
        break;
      case '9599909069117':
        document.querySelector('#swap-product--memory-foam input').checked = true;
        
        break;
      case '9599908806973':
        document.querySelector('#swap-product--memory-foam input').checked = true;
        
        break; 
      default:
    }
  }

  document.querySelectorAll('.product-media__image').forEach(media => {
    media.addEventListener('click', function(){
      if(media.classList.contains('active')){
        media.classList.remove('active');
      }else{
        media.classList.add('active');
      }
      media.addEventListener('mousemove', function zoomImage(event){
        zoom(event);
      })
    })
  })

  function toggleVariant() {
    document.querySelector('.select-popout__toggle').addEventListener('click', function(){
        console.log("---clickeed")
      var isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !isExpanded);
      document.querySelector('.zin-select-popout__list').classList.toggle('select-popout__list--visible');
    })
  }

  function zoom(e){
    var zoomer = e.currentTarget;
    e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
    e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
    x = offsetX/zoomer.offsetWidth*100
    y = offsetY/zoomer.offsetHeight*100
    zoomer.style.backgroundPosition = x + '% ' + y + '%';
  }

  initSwiper();

  initVariant();

  swapProduct();

  
  document.querySelectorAll('.select-popout__list__scroll .select-popout__item').forEach(button => {
    button.addEventListener('click', function(){
      let popoutText = this.querySelector('.select-popout__option').dataset.value;
      let optionPrice = this.querySelector('.option_price').innerHTML;
      let saveText = this.querySelector('.save_text').innerHTML;
      console.log(popoutText, 'popoutText');
      let currentId = document.querySelector('[data-current-id]').dataset.currentId;
      document.querySelectorAll('.product-variant__image')?.forEach(element => {
        element.closest('.product-wrapper__item').querySelector('.atc_button').classList.add('hidden');
        element.closest('.product-wrapper__item').querySelector('.shop_now').classList.remove('hidden');
      })
      document.querySelector(`.find-perfect-product [data-product-id="${currentId}"]`)?.querySelector('.shop_now').classList.add('hidden');
      document.querySelector(`.find-perfect-product [data-product-id="${currentId}"]`)?.querySelector('.atc_button').classList.remove('hidden');
      console.log(currentId, 'currentId');
      document.querySelector('.selected_option .option_price').innerHTML = optionPrice;
      document.querySelector('.selected_option .save_text').innerHTML = saveText;
      document.querySelectorAll('.mellow-perfect-product .price-with-button .variant_price').forEach(item => {
        if(item.dataset.variantTitle.trim() == popoutText){
          item.classList.remove('hidden')
        }else{
          item.classList.add('hidden');
        }
      })
      
      document.querySelectorAll('.variants-wrapper .variant_item').forEach(variantItem => {
        let variantTitle = variantItem.dataset.variantTitle;
        if(variantTitle.includes(popoutText)){
          let mattressHeight = variantItem.dataset.height;
          let selectedVariant= [];
          let variantAvailable = variantItem.dataset.available;
          let variantOrderAvailable = variantItem.dataset.orderAvailable;
          let variantOrderDescription = variantItem.dataset.orderDescription;
          let variantShippingDate = variantItem.dataset.expectedDate;
          let variantExpectShippingDate = variantItem.dataset.shippingDate;
          let variantOrderButton = variantItem.dataset.orderButton;
          let variantQuantity = variantItem.dataset.qty;
          let variantID = variantItem.dataset.variantId;
          console.log(mattressHeight, 'mattressHeight');
          document.querySelectorAll('.mattress-height').forEach(button => {
            button.value = mattressHeight;
          })

          document.querySelectorAll(".variant_radio_input:checked")?.forEach(item => {
            let variantValue = item.value;
            selectedVariant.push(variantValue);
          })

          if(document.querySelector('.select-popout__item--current')){
            let selectedValue = document.querySelector('.select-popout__item--current .select-popout__option').dataset.value;
            selectedVariant.push(selectedValue);
          }

          let variandData = JSON.parse(document.querySelector('.variant_data-wrapper [type="application/json"]').textContent);

          let currentVariant = variandData.find((variant) => {
            return !variant.options.map((option, index) => {
              return selectedVariant[index] === option;
            }).includes(false);
          });

          console.log(currentVariant, 'currentVariant');

          let currentVariantId = currentVariant.id;

          // document.querySelector('.product__submit__item.atc_button:not(.hidden)').closest('.price-with-button').querySelector('[data-product-select]').value = variantID;
      
          if(variantAvailable == 'true'){
            if(document.querySelector('.product__submit__item.atc_button:not(.hidden)')?.querySelector('.product__submit__add')?.disabled){
              if(variantQuantity < 1 && variantOrderAvailable){
                document.querySelector('.product__submit__item.atc_button:not(.hidden)').querySelector('[data-add-to-cart]').innerHTML ='Pre Order';
              }else{
                document.querySelector('.product__submit__item.atc_button:not(.hidden)').querySelector('[data-add-to-cart]').innerHTML ='Add to Cart';
                document.querySelectorAll('.mattress-wrapper').forEach(item =>{
                  item.innerHTML = '';
                });
              }
            }else{
              setTimeout(changeButtontext, 300);
              function changeButtontext(){
                if(variantQuantity < 1 && variantOrderAvailable){
                  //document.querySelector('.product__submit__item.atc_button:not(.hidden)').querySelector('[data-add-to-cart]').innerHTML ='Pre Order';
                }else{
                  // document.querySelector('.product__submit__item.atc_button:not(.hidden)').querySelector('[data-add-to-cart]').innerHTML ='Add to Cart';
                  document.querySelectorAll('.mattress-wrapper').forEach(item =>{
                    item.innerHTML = '';
                  });
                }
              }
            }
            console.log(variantQuantity, 'variantQuantity');
            if(variantID == currentVariantId){
              console.log(variantOrderAvailable, 'variantOrderAvailable');
              if(variantQuantity < 1 && variantOrderAvailable){
                document.querySelector('.variant__countdown--in').textContent = 'Item is Pre Order';
                document.querySelector('.order-expected_date')?.classList.remove('hidden');
                document.querySelectorAll('.mattress-wrapper').forEach(item =>{
                  item.innerHTML = '<input type="hidden" class="mattress-pre-order" name="properties[pre_order]" value="" /><input type="hidden" class="mattress-order-expected_date" name="properties[expected_ship_date]" value="" /><input type="hidden" class="mattress-order-expected_dates" name="properties[_expected_ship_date]" value="" />';
                });
                document.querySelectorAll('.mattress-order-expected_date')?.forEach(order => {
                  order.value = variantShippingDate;
                })
                console.log(variantExpectShippingDate, 'variantExpectShippingDate');
                document.querySelectorAll('.mattress-order-expected_dates')?.forEach(order => {
                  order.value = variantExpectShippingDate;
                })
                document.querySelector('.custom_add-button').textContent = 'Pre Order';
                document.querySelectorAll('.mattress-pre-order')?.forEach(order => {
                  order.value = 'This item is a Pre-Order';
                })
                setTimeout(changeButton, 100);
                function changeButton() {
                  if(document.querySelector('.product_add_to_cart-button .product__submit__add [data-add-to-cart-text]')){
                    document.querySelector('.product_add_to_cart-button .product__submit__add [data-add-to-cart-text]').textContent = 'Pre Order';
                  }
                }
                if(document.querySelector('.order-expected_date')){
                  document.querySelector('.pre-order__description').textContent = variantOrderDescription;
                  document.querySelector('.pre-order__shipping-date').textContent = variantShippingDate;
                  document.querySelector('.order-expected_date').textContent = variantShippingDate;
                }
                document.querySelector('.pre-order-wrapper')?.classList.remove('hidden');
              }
              if(variantQuantity > 0){
                document.querySelector('.product__form__wrapper').classList.remove('variant--soldout');
                document.querySelector('.custom_add-button').textContent = 'Add To Cart';
                document.querySelectorAll('.mattress-pre-order')?.forEach(order => {
                  order.value = '';
                })
                document.querySelector('.product_add_to_cart-button [data-add-to-cart-text]').textContent = 'Add To Cart';
                if(document.querySelector('.product__submit__item.atc_button:not(.hidden) .product__submit__add')){
                  document.querySelector('.product__submit__item.atc_button:not(.hidden) .product__submit__add').textContent = 'Add to Cart';
                }
                if(document.querySelector('.product__submit__item.atc_button:not(.hidden) .product__submit__add')){
                  document.querySelector('.product__submit__item.atc_button:not(.hidden) .product__submit__add').disabled = false;
                }
                if(document.querySelector('.pre-order-wrapper')){
                  document.querySelector('.pre-order-wrapper').classList.add('hidden');
                  document.querySelector('.order-expected_date').classList.add('hidden');
                }
                document.querySelector('.variant__countdown--in').textContent = 'Item is in stock';
              }
            }
          }else{
            document.querySelector('.pre-order-wrapper')?.classList.add('hidden');
            document.querySelector('.order-expected_date').classList.remove('hidden');
            document.querySelector('.product__form__wrapper').classList.add('variant--soldout');
            document.querySelector('.custom_add-button').textContent = 'Sold Out - Notify Me When It’s Available';
            if(document.querySelector('.product__submit__item.atc_button:not(.hidden) .product__submit__add')){
              document.querySelector('.product__submit__item.atc_button:not(.hidden) .product__submit__add').textContent = 'Sold Out';
            }
            if(document.querySelector('.product__submit__item.atc_button:not(.hidden) .product__submit__add')){
              document.querySelector('.product__submit__item.atc_button:not(.hidden) .product__submit__add').disabled = true;
            }
            document.querySelectorAll('.mattress-order-expected_date')?.forEach(order => {
              order.value = '';
            })
            document.querySelectorAll('.mattress-order-expected_dates')?.forEach(order => {
              order.value = '';
            })
            document.querySelectorAll('.mattress-pre-order')?.forEach(order => {
              order.value = '';
            })
          }
        }
      })

      if(this.closest('.sticky-atc') && window.innerWidth < 767) {
        document.querySelector('.sticky-atc .select-popout__list').classList.add('select-popout__list--visible');
        document.querySelector('.sticky-atc .select-popout__toggle').setAttribute('aria-expanded', true);
      }
    })
  })

  let popupText = document.querySelector('.select-popout__value').dataset.popoutText;

  // document.querySelectorAll('.select-popout__list__scroll .select-popout__item').forEach(item => {
  //   let itemText = item.querySelector('.select-popout__option').dataset.value;
  //   if(itemText.includes('Queen')){
  //     item.click();
  //   }

  // })

  document.querySelector('.select-popout__item--current a').click();

  document.querySelector('.custom_add-button').addEventListener('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    document.querySelector('.product__submit__holder .product__submit__buttons .product__submit__add').click();
  })

  window.onload = (event) => {
    let stickyATC = document.querySelector('.sticky-atc');
    var formHeight = 0;
    function triggerStickyAtc() {
      let formBottom = document.querySelector('.product-submit-form').offsetTop + document.querySelector('.product-submit-form').offsetHeight
      if(window.scrollY > formBottom - 100 && !document.getElementById('SiteHeader').classList.contains('sticky-form')) {
        document.getElementById('SiteHeader').classList.add('sticky-form');
        document.querySelector('body').classList.add('sticky-add-to-cart');
        stickyATC.appendChild(document.querySelector('.product__title-and-price'));
        stickyATC.appendChild(document.querySelector('.product__form__wrapper'));
      }
      if(!document.querySelector('.product-submit-form').querySelector('.product__form__wrapper')) document.querySelector('.product-submit-form').style.minHeight = `${formHeight}px`;
      else {
        formHeight = document.querySelector('.product-submit-form').querySelector('.product__form__wrapper').offsetHeight;
        document.querySelector('.product-submit-form').style.minHeight = 0;
      }
      if(window.scrollY <= formBottom - 100 && document.getElementById('SiteHeader').classList.contains('sticky-form')) {
        document.getElementById('SiteHeader').classList.remove('sticky-form');
        document.querySelector('body').classList.remove('sticky-add-to-cart');
        document.querySelector('.form__wrapper').prepend(document.querySelector('.product__title-and-price'));
        document.querySelector('.product-submit-form').prepend(document.querySelector('.product__form__wrapper'));
      }
    }
    window.addEventListener("scroll", (event) => {
      triggerStickyAtc();
  });

    triggerStickyAtc();
    document.querySelector('.select-popout__list-close')?.addEventListener('click', function(){
      document.querySelector('.select-popout__list').classList.remove('select-popout__list--visible');
      document.querySelector('.select-popout__toggle').setAttribute('aria-expanded', false);
    });
  };

  function initSwiper(){
    var galleryThumbs = new Swiper(`.product-single__gallery .gallery-thumbs`, {
      centeredSlides: false,
      spaceBetween: 10,
      loopedSlides: 1,
      slideToClickedSlide: true,
      slidesPerView: 4,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });

    var galleryTop = new Swiper(`.product-single__gallery  .gallery-top`, {
      loop: true,
      loopedSlides: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: `.product-single__gallery .swiper-button-next`,
        prevEl: `.product-single__gallery .swiper-button-prev`,
      },
      pagination: {
        el: ".product-single__gallery .swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '" data-pagination-index="'+(index+1)+'"></span>';
        },
      },
    });

    document.querySelector('.product-single__gallery .gallery-thumbs')?.querySelectorAll('.swiper-slide').forEach(slider => {
      slider.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
      let index = this.querySelector('.product-single__thumbnail').dataset.number;
      document.querySelector('.product-single__gallery').querySelector(`[data-pagination-index="`+index+`"`).click();
      })
    })
  }

  function swapProduct(){
    document.querySelectorAll('.swap-product__button').forEach(radioButton => {
      radioButton.addEventListener('change', function(){
        let swapProductLink = radioButton.querySelector('label').dataset.productLink;
        // let materialValue = document.querySelector('.zin-material-radio .zin-radio__input:checked').dataset.value;
        if(materialValue == 'Hybrid'){
          document.querySelector('#swap-product--hybrid')?.click();
        }else{
          document.querySelector('#swap-product--memory-foam')?.click();
        }
        document.querySelectorAll('.mellow_product').forEach(mellowProduct => {
          if(mellowProduct.dataset.productUrl == swapProductLink){
            selectedId = mellowProduct.querySelector('.selected_variants').textContent;
            if(selectedId){
              productUrl = swapProductLink+`?variant=${selectedId}`;
            }
          }
        })

        
        console.log(productUrl, 'productUrl');
        window.location.href = productUrl;
      })
    })
  }

});